<app-modal-container>
    <span title>Create Payment Method</span>
    <ng-container controls>
        <app-edit-view-actions completeText="Close"
                    [hideCancelButton]="true"
                    [disabled]="false"
                    (completed)="completeAction()">
                </app-edit-view-actions>
    </ng-container>
    <p description>
        Please provide the details of the new credit or payment card that you wish to use for your subscription.
    </p>
    <ng-container>
        <app-payment-method-stripe [organisation]="org"
                (methodCreated)="methodCreated($event)"></app-payment-method-stripe>
    </ng-container>
</app-modal-container>